export default __webpack_public_path__ + "static/media/BB_44.cc4773ee.png";